import Cta from '@/components/ui/buttons/Cta';
import BlockContent from '@sanity/block-content-to-react';
import { portableTextSerializer } from '@/utils/helpers';
import React from 'react';
import styles from './styles.module.css';

interface CTAListProps {
  content?: Record<string, unknown>;
  cta?: Record<string, unknown>;
  textColor: Record<string, unknown>;
  bgColor: Record<string, unknown>;
  bgGradient: Record<string, unknown>;
}

const CTAList: React.FC<CTAListProps> = ({ cta, content, textColor, bgColor, bgGradient }) => {
  const wrapperRef = React.useRef(null);
  const ctaRef = React.useRef(null);

  React.useEffect(() => {
    if (cta) {
      wrapperRef.current.style.setProperty('--fontSize', `22px`);
    }
    const typedBgColor = bgColor as { hex?: string } | undefined;
    if (typedBgColor?.hex) {
      wrapperRef.current.style.setProperty('--bgColor', `${typedBgColor.hex}`);
    }
    const typedBgGradient = bgGradient as
      | {
          gradientDirection?: string;
          colorStart?: { hex?: string };
          colorStop?: { hex?: string };
          opacity?: number;
        }
      | undefined;
    if (typedBgGradient?.gradientDirection && typedBgGradient?.colorStart?.hex && typedBgGradient?.colorStop?.hex) {
      wrapperRef.current.style.setProperty(
        '--bgGradient',
        `linear-gradient(to
          ${typedBgGradient.gradientDirection},
          ${typedBgGradient.colorStart.hex} 0%,
          ${typedBgGradient.colorStop.hex} 100%)`,
      );

      if (typedBgGradient?.opacity) {
        wrapperRef.current.style.setProperty('--gradientOpacity', `${typedBgGradient.opacity}`);
      }
    }
  }, [wrapperRef, cta, bgColor, bgGradient, textColor]);

  React.useEffect(() => {
    const typedTextColor = textColor as { hex?: string } | undefined;
    if (typedTextColor?.hex) {
      if (wrapperRef.current) {
        wrapperRef.current.style.setProperty('--fontColor', `${typedTextColor.hex}`);
      }
      if (ctaRef.current) {
        ctaRef.current.style.setProperty('--ctaFontColor', `${typedTextColor.hex}`);
      }
    }
  }, [ctaRef, textColor]);

  return (
    <section className={styles.ctaList} ref={wrapperRef}>
      <div ref={wrapperRef} className={styles.list}>
        {content && <BlockContent blocks={content} serializers={portableTextSerializer} />}
        {cta && (
          <Cta className={styles.ctaLink} to={(cta as { route: string }).route} type="link" ref={ctaRef}>
            {(cta as { title: string }).title}
          </Cta>
        )}
      </div>
    </section>
  );
};

export default CTAList;
